module.exports = __webpack_public_path__ + "img/ico-check-on.18df197c.svg";